import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { CommonapiService } from 'src/app/Module/Shared/Service/Commonapi.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { DashBoardService } from 'src/app/Module/Core/DashBoard/DashBoard.service';
import { GoogleMapCustomerService } from './GoogleMapCustomer.service';

@Component({
  selector: 'app-GoogleMapCustomer',
  templateUrl: './GoogleMapCustomer.component.html'
})
export class GoogleMapCustomerComponent implements OnInit,OnDestroy {

  @Output() CallParent: EventEmitter<any> = new EventEmitter();
  topbusinessList :any= [];
  bootombusinessList :any= [];
  temptopbusinessList :any= [];
  StoragetopbusinessList :any=[];
  tempStoragetopbusinessList :any=[];
  show = false;
  mappingConfirmationshow = false;
  googleLinkClicked: any = false;
  googlemapstate: any = {
    customername: "",
    meetingaddress1: "",
    placeID: "",
    latitude: "",
    longitude: "",
    srcfrm: "",
    MapCustomerID: { value: "", iserr: false, err_txt: "" },
  }
  constructor(private gapi: GoogleMapCustomerService,private Winfoapi: CommonapiService, private dashBoardapi: DashBoardService, private router: Router) { }


  data: any = {};
  VP_Subscription: Subscription;
  ngOnInit() {
    this.VP_Subscription = this.gapi.Receive_info.subscribe((value) => {
      this.topbusinessList = [];
      this.bootombusinessList = [];
      this.temptopbusinessList = [];
      this.googleLinkClicked = false;
      this.show = false;

     // console.log("value", value)

      this.data = value.data;
      console.log(" this.data ",  this.data )

      this.googlemapstate.customername = this.data.customername;
      this.googlemapstate.meetingaddress1 = this.data.meetingaddress1;
      this.googlemapstate.placeID = this.data.placeid;
      this.googlemapstate.latitude = this.data.lat+"";
      this.googlemapstate.longitude = this.data.long+"";
      this.googlemapstate.srcfrm = this.data.srcfrm;


      this.getNearbyBusiness();

    });
  }

  ngOnDestroy(){
    // prevent memory leak when component destroyed
    this.VP_Subscription.unsubscribe();
  }
  getNearbyBusiness()
  {
      var postdata = {
        "latitude": this.googlemapstate.latitude, "longitude": this.googlemapstate.longitude, "url": environment.apiurl + this.router.url,
        "googleLocationCall": "0", "existingPlaceID":"1"
      };
      this.Winfoapi.loader.startLoading();
      this.dashBoardapi.GetNearByBusiness(postdata, false).then(data => {


        if (data && data != undefined && data != '[]') {
        //  console.log("-----GetNearByBusiness data-----", data.salesNearByBusiness)
          //console.log("GetNearByBusiness data1", data.salesNearByBusiness.length)
          this.bootombusinessList = data.salesNearByBusiness;
          this.googleLinkClicked = true;

        }

        //this.getBusiness();
        this.show = true;
        this.Winfoapi.loader.stopLoading();

      })
    }

    getBusiness(){

      this.topbusinessList=[];

        this.temptopbusinessList = this.Winfoapi.get_local_storage("sales_nearBybusinessdata", true);

        //console.log(this.temptopbusinessList);
        if(this.temptopbusinessList != 'undefined')
        {
          this.temptopbusinessList.map((x, index) => {

                // if(index== this.markerId)
                if(x.latitude == this.googlemapstate.latitude && x.longitude == this.googlemapstate.longitude && x.place_id == this.googlemapstate.placeID)
                {
                  this.topbusinessList.push(x);
                }

          })

        }
        //console.log('popup' ,this.topbusinessList);
    }

    googleMappingYesNo()
    {
      this.mappingConfirmationshow = true;
    }
    googleMappingCancel()
    {
      this.mappingConfirmationshow = false;
      //this.show = false;
    }

    googleMappingYes()
    {
      this.mappingConfirmationshow = false;
      this.UpdateGoogleMapCustomer();
    }

    UpdateGoogleMapCustomer()
    {
      let isvalid = true;
      let customerID = JSON.stringify(this.googlemapstate.MapCustomerID.value.customer_id);
      let googleCustomerName = this.googlemapstate.customername;
      
      
      if (customerID != "" && customerID != undefined && customerID != "undefined") {
        //this.state.purposeofVisitradioOther.iserr = false;
        //this.state.purposeofVisitradioOther.err_txt = "";

      } else {
        //this.state.purposeofVisitradioOther.iserr = true;
        //this.state.purposeofVisitradioOther.err_txt = "Enter other";
        isvalid = false;

      }

      if(isvalid)
      {
        var postdata = {
          "customerId": customerID+"", "placeId": this.googlemapstate.placeID,
          "latitude": this.googlemapstate.latitude, "longitude": this.googlemapstate.longitude,
          "googleCustomerName": googleCustomerName,
        };

        this.Winfoapi.loader.startLoading();
        this.dashBoardapi.LinkPlaceID(postdata, false).then(data => {

          if (data && data != undefined && data != '[]') {
            console.log("-----LinkPlaceID data-----", data)

              if(data.id > 0)
              {


                  if(this.googlemapstate.srcfrm != "7")
                  {
                    this.tempStoragetopbusinessList = this.Winfoapi.get_local_storage("sales_nearBybusinessdata", true);

                    if(this.tempStoragetopbusinessList != 'undefined')
                    {
                      this.StoragetopbusinessList=[];

                      this.tempStoragetopbusinessList.map((x, index) => {

                            if(x.place_id != this.googlemapstate.placeID)
                            {
                              this.StoragetopbusinessList.push(x);
                            }

                      })

                      this.show = false;
                      if(this.tempStoragetopbusinessList != '[]' && this.tempStoragetopbusinessList != undefined)
                      {
                        this.dashBoardapi.api.set_local_storage("sales_nearBybusinessdata", this.StoragetopbusinessList);
                        window.location.reload();
                      }

                    }
                    else
                    {
                      this.show = false;
                    }

                  }
                  else
                  {
                    this.show = false;
                    window.location.reload();
                  }
              }
          }

          this.Winfoapi.loader.stopLoading();

        })

      }


    }

    addGoogleCustomer()
    {
      this.show = false;
      this.router.navigate(['/user/customer'], { queryParams: { placeid: this.googlemapstate.placeID } });

    }

    CloseGoogleMapCustomer()
    {
      //this.Callparentfunc();
      this.show = false;

      //this.router.navigate(['/user/dashboard'], { queryParams: { id: ''} });
     // this.Callparentfunc(0);
    }

    Callparentfunc(status,data=''){
      this.CallParent.emit({status:status,data:data});
    }

    getAddress(obj) {
      let address = obj.meeting_address1;

      if (obj.meeting_address2 != null && obj.meeting_address2 != '' && obj.meeting_address2 != ',') {
        address += ', ' + obj.meeting_address2;
      }

      if (obj.meeting_area != null && obj.meeting_area != '') {
        address += ', ' + obj.meeting_area;
      }
      //landmark
      if (obj.meeting_city != null && obj.meeting_city != '') {
        address += ', ' + obj.meeting_city;
      }
      if (obj.meeting_state != null && obj.meeting_state != '') {
        address += ', ' + obj.meeting_state;
      }
      if (obj.meeting_country != null && obj.meeting_country != '') {
        address += ', ' + obj.meeting_country;
      }
      //address +=  ', ' + obj.city + ', ' + obj.billing_state + ', ' + obj.billing_country;

      return address;
    }

}
